window.addEventListener('load', function () {
  if (document.querySelector('ui-dialog')) {
    document.querySelectorAll('form input').forEach(function (input) {

      if (input.hasAttribute('required')) {
        input.closest('.js-form-item').classList.add('required');
      }

      const descriptionElement = input.closest('.js-form-item').querySelector('.description');
      if (descriptionElement !== null) {
        input.closest('.js-form-item').classList.add('description');
      }

      if (input.classList.contains('form-date')) {
        flatpickr(input, {});
      }
    });

    if (document.querySelectorAll(".ui-dialog-buttonset.form-actions .button-red").length === 0) {
      document.querySelectorAll(".ui-dialog-buttonset.form-actions button").forEach(function (button) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('button-red', 'input-button-field');
        button.parentNode.insertBefore(wrapper, button);
        wrapper.appendChild(button);
      });
    }

    document.querySelectorAll('form input').forEach(function (input) {
      if (input.hasAttribute('required')) {
        input.closest('.js-form-item').classList.add('required');
      }

      const descriptionElement = input.closest('.js-form-item').querySelector('.description');
      if (descriptionElement !== null) {
        input.closest('.js-form-item').classList.add('description');
      }

      if (input.classList.contains('form-date')) {
        const calendar = flatpickr(input, {
          dateFormat: 'm/d/Y',
          disableMobile: true
        });

        document.querySelector('.ui-dialog .ui-dialog-content').addEventListener('scroll', function () {
          calendar._positionCalendar();
        });
      }
    });

    if (document.querySelector(".ui-dialog") !== null) {
      document.body.classList.add("popup-open");

      document.querySelector(".ui-dialog .ui-dialog-titlebar button").addEventListener("click", function (e) {
        document.body.classList.remove("popup-open");
      });

      document.querySelector(".ui-widget-overlay").addEventListener("click", function (e) {
        document.body.classList.remove("popup-open");
        // document.documentElement.classList.remove("popup-open");
        document.querySelector(".ui-widget.ui-widget-content").remove();
      });
    }
  }
});
